import { render, staticRenderFns } from "./AdministratorCreate.vue?vue&type=template&id=2164c018"
import script from "./AdministratorCreate.vue?vue&type=script&lang=ts"
export * from "./AdministratorCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports